import { create } from 'zustand'
import { getUserByToken, updateUser } from '@/api/user'
import { queryClient } from '@/main'

export const USER_CURRENT_QUERY_KEY = ['users', 'current'] as const

interface UserStore {
  user: {
    userData: User | null
    activeTeam: OrganizationDetails | null
    getUserData: () => Promise<void>
    setActiveTeam: (team: OrganizationDetails) => Promise<void>
    resetUser: () => void
  }
}

export const useUserStore = create<UserStore>((set) => ({
  user: {
    userData: null,
    activeTeam: null,

    getUserData: async () => {
      try {
        const response = await queryClient.fetchQuery({
          queryKey: USER_CURRENT_QUERY_KEY,
          queryFn: getUserByToken,
          staleTime: 0,
        })
        set((state) => ({
          user: {
            ...state.user,
            userData: response,
            activeTeam: response.active_organization,
          },
        }))
      } catch {
        return
      }
    },

    setActiveTeam: async (team: OrganizationDetails) => {
      await updateUser({ active_organization: team.external_id })
      queryClient.setQueryData<User | undefined>(
        USER_CURRENT_QUERY_KEY,
        (currentUser) =>
          currentUser
            ? { ...currentUser, active_organization: team }
            : currentUser
      )
      set((state) => ({
        user: {
          ...state.user,
          activeTeam: team,
          userData: state.user.userData
            ? { ...state.user.userData, active_organization: team }
            : null,
        },
      }))
      queryClient.cancelQueries()
      queryClient.invalidateQueries()
    },

    resetUser: () => {
      queryClient.removeQueries({ queryKey: USER_CURRENT_QUERY_KEY })
      set((state) => ({
        user: {
          ...state.user,
          userData: null,
          activeTeam: null,
        },
      }))
    },
  },
}))
